/* eslint-disable max-len */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import style from './PoltroneTile.module.scss';
import TextField from '../../../../components/TextField/TextField';
import IconButton from '../../../../components/Buttons/IconButton/IconButton';
import AddIcon from '../../../../components/Icons/AddIcon';
import RemoveIcon from '../../../../components/Icons/RemoveIcon';

function PoltroneTile({
  poltrone, index, setFieldValue,
}) {
  return (
    <div className={clsx(style.poltrone__tile)}>
      <TextField id="poltrone__nome" placeholder={poltrone.at(index).nome} name={poltrone.at(index).nome} onChange={(e) => setFieldValue(`poltrone[${index}].nome`, e.target.value)} />
      <div className={clsx(style.poltrone__buttons)}>
        {poltrone.length > 1 ? <IconButton icon={<RemoveIcon />} onClick={() => setFieldValue('poltrone', poltrone.filter((i) => i.idPoltrona !== poltrone.at(index).idPoltrona))} /> : ''}
        {poltrone.at(index).idPoltrona === poltrone.at(-1).idPoltrona
          ? <IconButton icon={<AddIcon />} onClick={() => setFieldValue('poltrone', [...poltrone, { nome: 'Marione', idPoltrona: poltrone.at(index).idPoltrona + 1 }])} />
          : ''}

      </div>
    </div>
  );
}

PoltroneTile.propTypes = {
  poltrone: PropTypes.arrayOf(PropTypes.shape({
    nome: PropTypes.string,
    idPoltrona: PropTypes.number,
  })).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,

};

export default PoltroneTile;
